import React, { useCallback } from 'react';
import { useParams, useHistory } from 'react-router-dom';

import CircularProgress from '@mui/material/CircularProgress';

import { useExercises } from 'modules/exercises/hooks';

import FillInTheBlanksExerciseForm from '../../components/FillInTheBlanksExerciseForm';
import { useFillInTheBlanksExercise, useFillInTheBlanksExerciseActions } from '../../hooks';
import { FillInTheBlanksExerciseInput } from '../../types/form';
import { FillInTheBlanksExercise } from '../../types';

const FillInTheBlanksExercisePage = () => {
  const history = useHistory();
  const { courseId, subjectId, exerciseId } = useParams<{ courseId: string; subjectId: string; exerciseId?: string }>();
  const { exercises, loading: loadingExercises } = useExercises({ courseId, subjectId });

  const {
    onCreateFillInTheBlanksExercise,
    createFillInTheBlanksExerciseLoading,
    onUpdateFillInTheBlanksExercise,
    updateFillInTheBlanksExerciseLoading,
  } = useFillInTheBlanksExerciseActions({ courseId, subjectId });
  const { exercise, loading } = useFillInTheBlanksExercise({ courseId, subjectId, exerciseId });

  const handleCreateFillInTheBlanksExercise = useCallback(
    (input: FillInTheBlanksExerciseInput) => {
      if (exerciseId) {
        onUpdateFillInTheBlanksExercise(exerciseId, input);
      } else {
        onCreateFillInTheBlanksExercise(input, (exercise: FillInTheBlanksExercise) => {
          history.replace(`/${courseId}/subjects/${subjectId}/exercises/exercise/FillInTheBlanksExercise/${exercise.id}`);
        });
      }
    },
    [onCreateFillInTheBlanksExercise, onUpdateFillInTheBlanksExercise, history, exerciseId, courseId, subjectId]
  );

  if (loading || loadingExercises) {
    return <CircularProgress />;
  }

  return (
    <FillInTheBlanksExerciseForm
      exercise={exercise}
      onSubmit={handleCreateFillInTheBlanksExercise}
      submitting={createFillInTheBlanksExerciseLoading || updateFillInTheBlanksExerciseLoading}
      exercisesCount={exercises?.length}
    />
  );
};

export default FillInTheBlanksExercisePage;
